// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================================
   WhoWeServe — Section 02
   ============================================================ */

.wws {
  background: var(--c-cream);
  padding-top: var(--section-y);
  /* No bottom padding — the mountain divider acts as the footer */
  padding-bottom: 0;
  overflow: hidden;
  position: relative;
}

/* ── Header ─────────────────────────────────────────────────── */
.wws__header {
  display: grid;
  grid-template-columns: 1fr 1fr auto;
  align-items: start;
  gap: clamp(2rem, 4vw, 3.5rem);
  margin-bottom: clamp(2.5rem, 5vw, 4.5rem);
}

/* Section number + rule + eyebrow */
.wws__section-label {
  display: flex;
  align-items: center;
  gap: 0.85rem;
  margin-bottom: 0.85rem;
}

.wws__num {
  font-family: var(--font-body);
  font-size: 0.72rem;
  font-weight: 500;
  letter-spacing: 0.1em;
  color: var(--text-muted);
  flex-shrink: 0;
}

.wws__rule {
  display: block;
  width: 1px;
  height: 1.1rem;
  background: var(--line);
  flex-shrink: 0;
}

/* Headline */
.wws__headline {
  font-size: clamp(2.8rem, 5.5vw, 5.2rem);
  color: var(--c-ink);
  line-height: 0.99;
  letter-spacing: -0.01em;
}

/* Body copy */
.wws__header-copy {
  font-family: var(--font-body);
  font-size: clamp(0.9rem, 1.1vw, 1.05rem);
  color: var(--text-muted);
  line-height: 1.65;
  max-width: 26rem;
  padding-top: 0.25rem;
}

/* Badge column */
.wws__badge-wrap {
  display: flex;
  justify-content: flex-end;
  align-items: flex-start;
  padding-top: 0.15rem;
}

/* ── Card grid ──────────────────────────────────────────────── */
.wws__grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: clamp(0.75rem, 1.5vw, 1.25rem);
  align-items: start;
}

/* ── Individual card ────────────────────────────────────────── */
.wws__card {
  background: var(--c-cream);
  display: flex;
  flex-direction: column;
  background: linear-gradient(360deg, rgba(244, 239, 230, 1) 0%, rgba(220, 204, 180, 1) 38%);
  transition: filter 0.5s ease-in-out;
}

.wws__card:hover {
  filter: drop-shadow(-10px -10px 5px rgba(0, 0, 0, 0.3));
}

/* Image container — aspect ratio locked */
.wws__card-img-wrap {
  position: relative;
  aspect-ratio: 3 / 4;
  overflow: hidden; /* torn edge extends below */
}

.wws__card-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center top;
  display: block;
}

/* Torn paper effect — irregular white/cream mask over the bottom of the photo */
.wws__card-tear {
  position: absolute;

  left: -30%;
  right: -2px;
  bottom: -35%;
  height: 50%;
  width: 200%;
}

.wws__card-tear.flip {
  transform: rotateY(180deg);
}

.wws__card-tear img {
  fill: var(--c-cream);
}

/* Card body beneath image */
.wws__card-body {
  padding: clamp(1rem, 1.5vw, 1.5rem) clamp(0.5rem, 1vw, 0.75rem) clamp(1.25rem, 2.5vw, 2rem);
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 0.65rem;
  transform: translateY(-10%);
}

/* Icon */
.wws__card-icon {
  font-size: clamp(2.5rem, 5.5vw, 3rem);
  color: var(--accent);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 0.1rem;
}

/* Card title */
.wws__card-title {
  font-size: clamp(0.95rem, 1.6vw, 1.3rem);
  color: var(--accent);
  letter-spacing: 0.06em;
  line-height: 1;
}

/* Card body copy */
.wws__card-text {
  font-family: var(--font-body);
  font-size: clamp(0.8rem, 1vw, 0.9rem);
  color: var(--text-muted);
  line-height: 1.6;
  max-width: 18rem;
}

/* ── Mountain / forest divider ──────────────────────────────── */
.wws__divider {
  width: 100%;
  /* Centre the mountain scene */
  display: flex;
  justify-content: center;
}

.wws__divider img {
  /* width: 100%; */
  max-width: 700px;
  max-height: 10dvh;
  height: 100%;
  display: block;
}

.border-bottom-div {
  border-bottom: 1px solid var(--c-ink);
  width: 100%;
}

/* Mountain back-range */
.wws__mtn-back {
  fill: var(--c-forest);
  opacity: 0.75;
}

/* Snow patches */
.wws__mtn-snow {
  fill: var(--c-cream);
  opacity: 0.65;
}

/* Pine trees */
.wws__tree {
  fill: var(--c-forest);
}

/* ── Responsive ─────────────────────────────────────────────── */
@media (max-width: 1099.98px) {
  .wws__header {
    grid-template-columns: 1fr;
  }
  .wws__badge-wrap {
    grid-column: 1;
    grid-row: auto;
    justify-content: flex-start;
  }
  .wws__grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 479.98px) {
  .wws__grid {
    grid-template-columns: 1fr;
  }
}

.wws__card.plant img {
  transform: translateX(-20%);
  width: 110%;
  max-width: 110%;
}

/* ── Enhanced scroll animations (added Section 04 pass) ─────── */

/* Cards: reveal with a subtle scale from below */
.wws__card {
  transform-origin: bottom center;
}

/* Headline clip — overflow already set; this smooths the entry */
.wws__headline {
  overflow: hidden;
}

/* Section divider fade-in */
.wws__divider {
  opacity: 0;
  transition: opacity 0.8s var(--ease);
}
.wws__divider.visible {
  opacity: 1;
}
`, "",{"version":3,"sources":["webpack://./src/components/Home/WhoWeServe.css"],"names":[],"mappings":"AAAA;;iEAEiE;;AAEjE;EACE,0BAA0B;EAC1B,6BAA6B;EAC7B,gEAAgE;EAChE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,kEAAkE;AAClE;EACE,aAAa;EACb,mCAAmC;EACnC,kBAAkB;EAClB,6BAA6B;EAC7B,yCAAyC;AAC3C;;AAEA,oCAAoC;AACpC;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,wBAAwB;EACxB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,UAAU;EACV,cAAc;EACd,uBAAuB;EACvB,cAAc;AAChB;;AAEA,aAAa;AACb;EACE,uCAAuC;EACvC,mBAAmB;EACnB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA,cAAc;AACd;EACE,6BAA6B;EAC7B,wCAAwC;EACxC,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,yBAAyB;EACzB,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA,kEAAkE;AAClE;EACE,aAAa;EACb,qCAAqC;EACrC,mCAAmC;EACnC,kBAAkB;AACpB;;AAEA,kEAAkE;AAClE;EACE,0BAA0B;EAC1B,aAAa;EACb,sBAAsB;EACtB,0FAA0F;EAC1F,mCAAmC;AACrC;;AAEA;EACE,uDAAuD;AACzD;;AAEA,0CAA0C;AAC1C;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB,EAAE,4BAA4B;AAChD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,2BAA2B;EAC3B,cAAc;AAChB;;AAEA,gFAAgF;AAChF;EACE,kBAAkB;;EAElB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,WAAW;EACX,WAAW;AACb;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,oBAAoB;AACtB;;AAEA,4BAA4B;AAC5B;EACE,2FAA2F;EAC3F,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,2BAA2B;AAC7B;;AAEA,SAAS;AACT;EACE,qCAAqC;EACrC,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA,eAAe;AACf;EACE,wCAAwC;EACxC,oBAAoB;EACpB,sBAAsB;EACtB,cAAc;AAChB;;AAEA,mBAAmB;AACnB;EACE,6BAA6B;EAC7B,qCAAqC;EACrC,wBAAwB;EACxB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,kEAAkE;AAClE;EACE,WAAW;EACX,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,WAAW;AACb;;AAEA,wBAAwB;AACxB;EACE,qBAAqB;EACrB,aAAa;AACf;;AAEA,iBAAiB;AACjB;EACE,oBAAoB;EACpB,aAAa;AACf;;AAEA,eAAe;AACf;EACE,qBAAqB;AACvB;;AAEA,kEAAkE;AAClE;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,cAAc;IACd,cAAc;IACd,2BAA2B;EAC7B;EACA;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,2BAA2B;EAC3B,WAAW;EACX,eAAe;AACjB;;AAEA,kEAAkE;;AAElE,iDAAiD;AACjD;EACE,+BAA+B;AACjC;;AAEA,iEAAiE;AACjE;EACE,gBAAgB;AAClB;;AAEA,4BAA4B;AAC5B;EACE,UAAU;EACV,oCAAoC;AACtC;AACA;EACE,UAAU;AACZ","sourcesContent":["/* ============================================================\n   WhoWeServe — Section 02\n   ============================================================ */\n\n.wws {\n  background: var(--c-cream);\n  padding-top: var(--section-y);\n  /* No bottom padding — the mountain divider acts as the footer */\n  padding-bottom: 0;\n  overflow: hidden;\n  position: relative;\n}\n\n/* ── Header ─────────────────────────────────────────────────── */\n.wws__header {\n  display: grid;\n  grid-template-columns: 1fr 1fr auto;\n  align-items: start;\n  gap: clamp(2rem, 4vw, 3.5rem);\n  margin-bottom: clamp(2.5rem, 5vw, 4.5rem);\n}\n\n/* Section number + rule + eyebrow */\n.wws__section-label {\n  display: flex;\n  align-items: center;\n  gap: 0.85rem;\n  margin-bottom: 0.85rem;\n}\n\n.wws__num {\n  font-family: var(--font-body);\n  font-size: 0.72rem;\n  font-weight: 500;\n  letter-spacing: 0.1em;\n  color: var(--text-muted);\n  flex-shrink: 0;\n}\n\n.wws__rule {\n  display: block;\n  width: 1px;\n  height: 1.1rem;\n  background: var(--line);\n  flex-shrink: 0;\n}\n\n/* Headline */\n.wws__headline {\n  font-size: clamp(2.8rem, 5.5vw, 5.2rem);\n  color: var(--c-ink);\n  line-height: 0.99;\n  letter-spacing: -0.01em;\n}\n\n/* Body copy */\n.wws__header-copy {\n  font-family: var(--font-body);\n  font-size: clamp(0.9rem, 1.1vw, 1.05rem);\n  color: var(--text-muted);\n  line-height: 1.65;\n  max-width: 26rem;\n  padding-top: 0.25rem;\n}\n\n/* Badge column */\n.wws__badge-wrap {\n  display: flex;\n  justify-content: flex-end;\n  align-items: flex-start;\n  padding-top: 0.15rem;\n}\n\n/* ── Card grid ──────────────────────────────────────────────── */\n.wws__grid {\n  display: grid;\n  grid-template-columns: repeat(5, 1fr);\n  gap: clamp(0.75rem, 1.5vw, 1.25rem);\n  align-items: start;\n}\n\n/* ── Individual card ────────────────────────────────────────── */\n.wws__card {\n  background: var(--c-cream);\n  display: flex;\n  flex-direction: column;\n  background: linear-gradient(360deg, rgba(244, 239, 230, 1) 0%, rgba(220, 204, 180, 1) 38%);\n  transition: filter 0.5s ease-in-out;\n}\n\n.wws__card:hover {\n  filter: drop-shadow(-10px -10px 5px rgba(0, 0, 0, 0.3));\n}\n\n/* Image container — aspect ratio locked */\n.wws__card-img-wrap {\n  position: relative;\n  aspect-ratio: 3 / 4;\n  overflow: hidden; /* torn edge extends below */\n}\n\n.wws__card-img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  object-position: center top;\n  display: block;\n}\n\n/* Torn paper effect — irregular white/cream mask over the bottom of the photo */\n.wws__card-tear {\n  position: absolute;\n\n  left: -30%;\n  right: -2px;\n  bottom: -35%;\n  height: 50%;\n  width: 200%;\n}\n\n.wws__card-tear.flip {\n  transform: rotateY(180deg);\n}\n\n.wws__card-tear img {\n  fill: var(--c-cream);\n}\n\n/* Card body beneath image */\n.wws__card-body {\n  padding: clamp(1rem, 1.5vw, 1.5rem) clamp(0.5rem, 1vw, 0.75rem) clamp(1.25rem, 2.5vw, 2rem);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  gap: 0.65rem;\n  transform: translateY(-10%);\n}\n\n/* Icon */\n.wws__card-icon {\n  font-size: clamp(2.5rem, 5.5vw, 3rem);\n  color: var(--accent);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 0.1rem;\n}\n\n/* Card title */\n.wws__card-title {\n  font-size: clamp(0.95rem, 1.6vw, 1.3rem);\n  color: var(--accent);\n  letter-spacing: 0.06em;\n  line-height: 1;\n}\n\n/* Card body copy */\n.wws__card-text {\n  font-family: var(--font-body);\n  font-size: clamp(0.8rem, 1vw, 0.9rem);\n  color: var(--text-muted);\n  line-height: 1.6;\n  max-width: 18rem;\n}\n\n/* ── Mountain / forest divider ──────────────────────────────── */\n.wws__divider {\n  width: 100%;\n  /* Centre the mountain scene */\n  display: flex;\n  justify-content: center;\n}\n\n.wws__divider img {\n  /* width: 100%; */\n  max-width: 700px;\n  max-height: 10dvh;\n  height: 100%;\n  display: block;\n}\n\n.border-bottom-div {\n  border-bottom: 1px solid var(--c-ink);\n  width: 100%;\n}\n\n/* Mountain back-range */\n.wws__mtn-back {\n  fill: var(--c-forest);\n  opacity: 0.75;\n}\n\n/* Snow patches */\n.wws__mtn-snow {\n  fill: var(--c-cream);\n  opacity: 0.65;\n}\n\n/* Pine trees */\n.wws__tree {\n  fill: var(--c-forest);\n}\n\n/* ── Responsive ─────────────────────────────────────────────── */\n@media (max-width: 1099.98px) {\n  .wws__header {\n    grid-template-columns: 1fr;\n  }\n  .wws__badge-wrap {\n    grid-column: 1;\n    grid-row: auto;\n    justify-content: flex-start;\n  }\n  .wws__grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n@media (max-width: 479.98px) {\n  .wws__grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n.wws__card.plant img {\n  transform: translateX(-20%);\n  width: 110%;\n  max-width: 110%;\n}\n\n/* ── Enhanced scroll animations (added Section 04 pass) ─────── */\n\n/* Cards: reveal with a subtle scale from below */\n.wws__card {\n  transform-origin: bottom center;\n}\n\n/* Headline clip — overflow already set; this smooths the entry */\n.wws__headline {\n  overflow: hidden;\n}\n\n/* Section divider fade-in */\n.wws__divider {\n  opacity: 0;\n  transition: opacity 0.8s var(--ease);\n}\n.wws__divider.visible {\n  opacity: 1;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
